
import { AreaActivities } from './areaActivities.model';
import { environment } from 'src/environments/environment';
import { Professions } from './professions.model';

export class CandidatesExperiences {
  private id: number;
  private company: string;
  private area_activity: AreaActivities;
  private position_level: string;
  private period_start: string;
  private period_end: string;
  private in_progress: string;
  private team_management: string;
  private job_title: string;
  private supervisor_title: string;
  private reason_for_leaving: string;
  private task_description: string;
  private work_description: string;
  private realisation: string;
  private certificate_path: string;
  private professions: Professions;

  constructor(CandidatesExperiences: any) {
    this.id = CandidatesExperiences.id;
    this.company = CandidatesExperiences.company;
    this.area_activity = CandidatesExperiences.area_activity;
    this.professions = (CandidatesExperiences.professions != undefined) ? new Professions(CandidatesExperiences.professions) : new Professions({});
    this.position_level = CandidatesExperiences.position_level;
    this.period_start = CandidatesExperiences.period_start;
    this.period_end = CandidatesExperiences.period_end;
    this.in_progress = CandidatesExperiences.in_progress;
    this.team_management = CandidatesExperiences.team_management;
    this.job_title = CandidatesExperiences.job_title;
    this.supervisor_title = CandidatesExperiences.supervisor_title;
    this.reason_for_leaving = CandidatesExperiences.reason_for_leaving;
    this.task_description = CandidatesExperiences.task_description;
    this.realisation = CandidatesExperiences.realisation;
    this.work_description = CandidatesExperiences.work_description;
    this.certificate_path = CandidatesExperiences.certificate_path;
  }

  getId(): number {
    return this.id;
  }

  getCompany(): string {
    return this.company;
  }

  getAreaActivity(): AreaActivities {
    return this.area_activity;
  }
  getProfessions(): Professions {
    return this.professions;
  }

  getPositionLevel(): string {
    return this.position_level;
  }

  getPeriodStart(): string {
    return this.period_start;
  }

  getPeriodEnd(): string {
    return this.period_end;
  }

  getInProgress(): string {
    return this.in_progress;
  }

  getTeamManagement(): string {
    return this.team_management;
  }

  getJobTitle(): string {
    return this.job_title;
  }

  getSupervisorTitle(): string {
    return this.supervisor_title;
  }

  getReasonForLeaving(): string {
    return this.reason_for_leaving;
  }

  getTaskDescription(): string {
    return this.task_description;
  }
  getRealisation(): string {
    return this.realisation;
  }
  getCertificatePath(): string {
    return (this.certificate_path != null && this.certificate_path != '') ? environment.apiUrl + this.certificate_path : this.certificate_path;
  }

}